import { onMounted, ref } from 'vue'

export default function useMounted() {
  const mounted = ref(false)
  onMounted(() => {
    // avoid animating on first load
    setTimeout(() => {
      mounted.value = true
    }, 100)
  })

  return mounted
}
